import { useMemo } from 'react';

import useRequest from '../useRequest';

const requestConfig = {
  listUrl: '/api/news/newsList.htm?type=0&size=10',
  detailUrl: '/api/news/newsDetail.htm',
};

export function useStoriesList({ lang, page }) {
  const { data, error } = useRequest({ url: `${requestConfig.listUrl}&page=${page}&lang=${lang}` });
  const result = useMemo(() => {
    if (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return { done: true, error };
    }
    if (data) {
      return {
        done: true,
        data: data?.newsList?.list || [],
        end: page * 10 >= Number(data?.newsList?.count),
      };
    }
    return {};
  }, [data, error]);
  return result;
}

export function useStoriesDetail({ id }) {
  const { data, error } = useRequest({ url: `${requestConfig.detailUrl}?id=${id}` });
  const result = useMemo(() => {
    if (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return { done: true, error };
    }
    if (data) {
      return {
        done: true,
        data: data?.news || {},
      };
    }
    return {};
  }, [data, error]);
  return result;
}

export default { useStoriesList, useStoriesDetail };
